/* ---------------------------
   UTILITY: WAIT FOR ELEMENT
---------------------------- */
function waitForElement(selector, callback) {
  const el = document.querySelector(selector);
  if (el) return callback(el);

  const observer = new MutationObserver(() => {
    const found = document.querySelector(selector);
    if (found) {
      observer.disconnect();
      callback(found);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

/* ---------------------------
   TRANSLATIONS
---------------------------- */
function applyTranslations() {
  const t = id => document.getElementById(id)?.value || null;

  // Form title
  const formTitle = document.querySelector('.onst-registration-form-container .title');
  if(formTitle && t('translation-title')) {
    formTitle.textContent = t('translation-title');
  }
  
  // Labels
  const labels = {
    'label[for="wRegisterForm-text-0"]': 'translation-first-name-label',
    'label[for="wRegisterForm-text-1"]': 'translation-last-name-label',
    'label[for="wRegisterForm-email-2"]': 'translation-email-label',
    'label[for="wRegisterForm-tel-3"]': 'translation-phone-label',
    'label[for="wRegisterForm-text-4"]': 'translation-company-label'
  };
  Object.entries(labels).forEach(([sel,id])=>{
    const el = document.querySelector(sel);
    if(el && t(id)) el.textContent = t(id);
  });

  // Placeholders
  const placeholders = {
    '#wRegisterForm-text-0': 'translation-first-name-placeholder',
    '#wRegisterForm-text-1': 'translation-last-name-placeholder',
    '#wRegisterForm-email-2': 'translation-email-placeholder',
    '#wRegisterForm-tel-3': 'translation-phone-placeholder',
    '#wRegisterForm-text-4': 'translation-company-placeholder'
  };
  Object.entries(placeholders).forEach(([sel,id])=>{
    const el = document.querySelector(sel);
    if(el && t(id)) el.placeholder = t(id);
  });

  // Errors
  const errors = {
    'input[name="wcustomer[first_name]"]': 'translation-first-name-error',
    'input[name="wcustomer[last_name]"]': 'translation-last-name-error',
    'input[name="wcustomer[email]"]': 'translation-email-error',
    'input[name="wcustomer[phone]"]': 'translation-phone-error',
    'input[name="company"]': 'translation-company-error'
  };

  Object.entries(errors).forEach(([sel,id]) => {
    const input = document.querySelector(sel);
    if (!input) return;
    const warning = input.closest('.onst-field')?.querySelector('.onst-warning');
    if (warning && t(id)) warning.textContent = t(id);
  });

  // Email validation messages
  const emailWarning = document.querySelector('.customer-email-onst');
  if (emailWarning) {
    if (t('translation-email-error')) {
      emailWarning.textContent = t('translation-email-error');
      emailWarning.dataset.required = t('translation-email-error');
    }
    if (t('translation-email-invalid')) {
      emailWarning.dataset.valid = t('translation-email-invalid');
    }
    if (t('translation-email-exists')) {
      emailWarning.dataset.already = t('translation-email-exists');
    }
  }

  // Newsletter checkbox (with typo-safe ID)
  const checkbox = document.querySelector('input[name="wcustomer[subscribe]"]');
  if(checkbox){
    const label = checkbox.closest('label');
    const span = label?.querySelector('.onst-field-roption-value');
    if(span && t('translation-newsletter-label')) span.textContent = t('translation-newsletter-label');
  }

  // Submit button
  const submitBtn = document.querySelector('button.onst-custom-form-submit');
  if(submitBtn && t('translation-submit-button')) submitBtn.childNodes[0].textContent = t('translation-submit-button');

  // Back to login
const backLogin = document.querySelector('.onst-backtologin');
if (backLogin) {
    const langPrefix = (window.location.pathname.match(/^\/([a-z]{2})\//) || [])[1] || '';
    const translation = document.getElementById('translation-back-to-login').value;
    backLogin.innerHTML = `<a href="/${langPrefix}/account/login">${translation}</a>`;
}

  // Success message
  const successMsg = document.querySelector('.onstw-register-message');
  if(successMsg && t('translation-success-message')) successMsg.textContent = t('translation-success-message');
}

/* ---------------------------
   PHONE CODE SYNC
---------------------------- */
const COUNTRY_TO_PHONE = {
  AF:"+93",AL:"+355",DZ:"+213",AD:"+376",AO:"+244",AR:"+54",AM:"+374",
  AU:"+61",AT:"+43",AZ:"+994",BS:"+1-242",BH:"+973",BD:"+880",BB:"+1-246",
  BY:"+375",BE:"+32",BZ:"+501",BJ:"+229",BT:"+975",BO:"+591",BA:"+387",
  BW:"+267",BR:"+55",BN:"+673",BG:"+359",BF:"+226",BI:"+257",KH:"+855",
  CM:"+237",CA:"+1",CV:"+238",CF:"+236",TD:"+235",CL:"+56",CN:"+86",
  CO:"+57",KM:"+269",CG:"+242",CR:"+506",HR:"+385",CU:"+53",CY:"+357",
  CZ:"+420",DK:"+45",DO:"+1-809",EC:"+593",EG:"+20",SV:"+503",EE:"+372",
  ET:"+251",FJ:"+679",FI:"+358",FR:"+33",DE:"+49",GH:"+233",GR:"+30",
  GL:"+299",GT:"+502",HN:"+504",HK:"+852",HU:"+36",IS:"+354",IN:"+91",
  ID:"+62",IR:"+98",IQ:"+964",IE:"+353",IL:"+972",IT:"+39",JM:"+1-876",
  JP:"+81",JO:"+962",KZ:"+7",KE:"+254",KW:"+965",LA:"+856",LV:"+371",
  LB:"+961",LR:"+231",LY:"+218",LT:"+370",LU:"+352",MG:"+261",MY:"+60",
  MV:"+960",ML:"+223",MT:"+356",MX:"+52",MC:"+377",MN:"+976",MA:"+212",
  MZ:"+258",MM:"+95",NA:"+264",NP:"+977",NL:"+31",NZ:"+64",NG:"+234",
  NO:"+47",OM:"+968",PK:"+92",PS:"+970",PA:"+507",PG:"+675",PY:"+595",
  PE:"+51",PH:"+63",PL:"+48",PT:"+351",QA:"+974",RO:"+40",RU:"+7",
  RW:"+250",SA:"+966",SN:"+221",RS:"+381",SG:"+65",SK:"+421",SI:"+386",
  ZA:"+27",KR:"+82",ES:"+34",LK:"+94",SE:"+46",CH:"+41",TW:"+886",
  TZ:"+255",TH:"+66",TR:"+90",UG:"+256",UA:"+380",AE:"+971",GB:"+44",
  US:"+1",UY:"+598",UZ:"+998",VE:"+58",VN:"+84",ZM:"+260",ZW:"+263"
};

function initPhoneCodeSync(){
  const country = Shopify.country;
  const phoneSelect = document.querySelector('.surecust-phone-input-wrapper select');
  if(!country||!phoneSelect) return;
  const setPhone = iso=>{
    const code = COUNTRY_TO_PHONE[iso?.toUpperCase()];
    if(!code) return;
    const opt=[...phoneSelect.options].find(o=>o.value===code);
    if(opt){
      phoneSelect.value=code;
      phoneSelect.dispatchEvent(new Event('change',{bubbles:true}));
    }
  };
  setPhone(country);
  country.addEventListener?.('change', e=>setPhone(e.target.value));
}

/* ---------------------------
   INITIALIZATION
---------------------------- */
waitForElement('.onst-register-form-fields', container=>{
  applyTranslations();
  if(window.MutationObserver){
    const observer=new MutationObserver(ms=>{
      if(ms.some(m=>m.addedNodes.length>0)) setTimeout(applyTranslations,50);
    });
    observer.observe(container,{childList:true,subtree:true});
  }
});

waitForElement('.surecust-phone-input-wrapper select', initPhoneCodeSync);

/* ---------------------------
   FIX NEWSLETTER CHECKBOX CLICK (typo-safe)
---------------------------- */
waitForElement('#wRegisterForm-subscibe-checkbox', checkbox=>{
  const label=checkbox.closest('label');
  if(!label) return;
  label.addEventListener('click', e=>{
    if(e.target===checkbox) return;
    checkbox.checked=!checkbox.checked;
    checkbox.dispatchEvent(new Event('change',{bubbles:true}));
  });
});
